module.exports = __webpack_public_path__ + "img/Big_12_CS_Logo.6a1ea9f5.png";